import { render, staticRenderFns } from "./Wrongbook.vue?vue&type=template&id=6825c455&scoped=true"
import script from "./Wrongbook.vue?vue&type=script&lang=js"
export * from "./Wrongbook.vue?vue&type=script&lang=js"
import style0 from "./Wrongbook.vue?vue&type=style&index=0&id=6825c455&prod&lang=scss&scoped=true"
import style1 from "./Wrongbook.vue?vue&type=style&index=1&id=6825c455&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6825c455",
  null
  
)

export default component.exports